module.exports = __webpack_public_path__ + "static/media/expo-4-2-caption.a6449c06.svg";